<template>
  <div>
    <el-tree
      :props="props"
      :load="loadNode"
      :default-expanded-keys="[0]"
      :current-node-key="curSelectKey"
      node-key="id"
      ref="folderTree"
      lazy >
    </el-tree>
    <div style="padding-top: 30px;padding-left: 30px">
      <el-button size="small" @click="cancleBtnClick">取 消</el-button>
      <el-button size="small" type="primary" @click="okBtnClick">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CloudDiskFolderTree',
  props: {
    disableList: {
      required: false
    }
  },
  data () {
    return {
      props: {
        label: 'name'
      },
      rootTreeData: [],
      curSelectKey: 0
    }
  },
  methods: {
    getSelectKey () {
      let key = this.$refs.folderTree.getCurrentKey()
      return key
    },
    okBtnClick () {
      this.$emit('okBtnClick')
    },
    cancleBtnClick () {
      this.$emit('cancleBtnClick')
    },
    loadNode (node, resolve) {
      console.log(node)
      let nodeId = 0
      if (node.data !== undefined && node.data !== null) {
        nodeId = node.data.id
      } else {
        let resItem = {id: 0, name: '所有资料'}
        let resArray = []
        resArray.push(resItem)
        resolve(resArray)
        return
      }
      let requestData = {parentid: nodeId, dir: 1}
      this.$api.cloudDisk.getFileList(requestData).then((res) => {
        if (res.code === 0) {
          if (res.data == null || res.data === undefined) {
            let curChildren = []
            resolve(curChildren)
          } else {
            let curChildren = this.formatResponseList(res.data)
            resolve(curChildren)
          }
        }
      })
    },
    formatResponseList (list) {
      let resList = []
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        let disabled = this.getItemIsDisabel(item.id)
        if (disabled === false) {
          let resItem = {id: item.id, parent: this.curTree}
          let isFolder = item.file_type === 0
          if (isFolder) {
            resItem.fileType = 0
            resItem.children = []
            resItem.name = item.name
            resItem.updateTime = item.update_time
          }
          resList.push(resItem)
        }
      }
      return resList
    },
    getItemIsDisabel (itemId) {
      for (let i = 0; i < this.disableList.length; i++) {
        let item = this.disableList[i]
        if (item.fileInfo.id === itemId) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cloudDisk/CloudDiskFolderTree.vue